export enum FloatingButtonActionType {
  PlatformSupport = 'platformSupport',
  ItSupport = 'itSupport',
  FinanceSupport = 'financeSupport',
  OfficeSupport = 'officeSupport',
  EducationSupport = 'educationSupport',
  AiChat = 'aiChat',
}

export interface FloatingButtonAction {
  type: FloatingButtonActionType;
  isDisabled?: boolean;
}
